"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMainCategories = void 0;
const selectMainCategories = (categories) => {
    const uniqueCategories = categories.data.filter((category) => category.attributes.parent_id === null);
    return uniqueCategories;
};
exports.selectMainCategories = selectMainCategories;
//# sourceMappingURL=helpers.js.map